import React from "react";
import ReactDOM from "react-dom";
import Router from "react-router-dom/Router";
// import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import configureStore, { history } from "redux/configureStore";
import { ThemeProvider } from "styled-components";
import routes from "./routes";
import { IntlProvider, addLocaleData } from "react-intl";
import ru from "react-intl/locale-data/ru";
import theme from "./theme";
import "./styles/index.scss";
import "font-awesome/css/font-awesome.css";

addLocaleData([...ru]);
const store = configureStore();

ReactDOM.render(
  <IntlProvider locale={"ru"}>
    <Provider store={store} key="provider">
      <ThemeProvider theme={theme}>
        <Router history={history}>{routes}</Router>
      </ThemeProvider>
    </Provider>
  </IntlProvider>,
  document.querySelector("#root")
);

// registerServiceWorker();
